module.exports = __webpack_public_path__ + "static/media/(000309).95a4f4e4.jpg";